// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bjTable-2022-2-23-16-56-17 .tags {\n  margin-top: 10px;\n}\n.bjTable-2022-2-23-16-56-17 .tags .el-tag {\n  margin: 4px;\n}\n.bjTable-2022-2-23-16-56-17 .el-tag--mini .el-icon-close {\n  color: #082dc3;\n  font-weight: bold;\n}\n.bjTable-2022-2-23-16-56-17 .hide-expand-icon .el-table__expand-icon {\n  display: none;\n}\n.bjTable-2022-2-23-16-56-17 .el-image__inner {\n  width: 50px;\n  height: 50px;\n}", ""]);
// Exports
module.exports = exports;
